/* eslint-disable react/jsx-no-literals -- Allow hard-coded translations for now */
'use client'

import { type JSX } from 'react'

import { useGlobalConfigContext } from '../../../../../global-config'
import { LOCALE } from '../../../../../i18n'
import { ProductPriceExplainerSection } from '../ProductPriceExplainerSection'

export const ProductPriceExplainerContentBe = (): JSX.Element => {
  const { locale } = useGlobalConfigContext()

  return (
    <div className="flex flex-col gap-6">
      <ProductPriceExplainerSection>
        {locale === LOCALE.FR_BE && (
          <p>
            Avantage total par rapport au prix de vente conseillé. Les prix de
            vente indiqués pour les produits sans marge réglementée sont des
            prix conseillés non contraignants.
          </p>
        )}
        {locale === LOCALE.NL_BE && (
          <p>
            Totaal voordeel op de adviesprijs. De vermelde verkoopprijzen die
            betrekking hebben op producten zonder wettelijk gereguleerde marges,
            zijn niet-bindende adviesprijzen.
          </p>
        )}
      </ProductPriceExplainerSection>
    </div>
  )
}
